import {
    ApiFragment,
    Comparable,
    EvaluateMediaPayload,
    Metadata,
    TaskKey,
    Trackable,
    UserFunction
} from '@stylehaven/components';
import { ExecutionId } from './brands/execution-id.entity';
import { ProcessId } from './brands/process-id.entity';
import { TaskId } from './brands/task-id.entity';
import { TaskVariableType } from './types/task-variable.type';

export interface IWorkflowTask {
    readonly TaskId: TaskId;
    readonly TaskName: string;
    readonly TaskKey: TaskKey;
    readonly Authorities: UserFunction[];
    readonly ProcessId: ProcessId;
    readonly ProcessName: string;
    readonly ExecutionId: ExecutionId;
    readonly DueDate: string;
    readonly CreationDate: string;
    readonly Variables?: Record<TaskVariableType, string | WorkflowTaskRemark[][]>;
    readonly Completable: boolean;
    readonly RelatedRecord: Metadata;
    readonly Roles: WorkflowTaskRole[];
}

export interface WorkflowTaskRole {
    readonly Id: string;
    readonly Name: string;
}
export interface WorkflowTaskRemark {
    readonly EvaluatorRemark: string;
    readonly EvaluatorId: string;
    readonly EvaluatorName: string;
    readonly EvaluatorApproval: EvaluateMediaPayload;
    readonly TaskKey: TaskKey;
}

export class WorkflowTask implements Comparable, Trackable, IWorkflowTask {
    readonly TaskId: TaskId;
    readonly TaskName: string;
    readonly TaskKey: TaskKey;
    readonly Authorities: UserFunction[];
    readonly ProcessId: ProcessId;
    readonly ProcessName: string;
    readonly ExecutionId: ExecutionId;
    readonly DueDate: string;
    readonly CreationDate: string;
    readonly Variables?: Record<TaskVariableType, string | WorkflowTaskRemark[][]>;
    readonly Completable: boolean;
    readonly RelatedRecord: Metadata;
    readonly FullRelatedRecord: ApiFragment;
    readonly Roles: WorkflowTaskRole[];
    readonly Initiator: string;

    constructor(task: IWorkflowTask) {
        Object.assign(this, task);
        this.FullRelatedRecord = new ApiFragment(task.RelatedRecord);
    }

    equals(other: any): boolean {
        if (!(other instanceof WorkflowTask)) {
            return false;
        }
        return this.ExecutionId === other.ExecutionId;
    }

    trackBy(): string {
        return this.ExecutionId;
    }
}
